module.exports = __webpack_public_path__ + "static/jem-779b6a308f6164e9334d898004b5caef.png";